import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { labelsApi } from "@/lib/api";
import { useOrganizationStore } from "@/stores/organizationStore";
import type { CreateLabel } from "@/types/labels";

type UpdateLabelVariables = { id: string } & Partial<
  Pick<
    CreateLabel,
    | "name"
    | "currency"
    | "payment_threshold"
    | "address"
    | "address_line_2"
    | "city"
    | "state"
    | "zip_code"
    | "country"
    | "tax_id"
    | "contact_name"
    | "contact_email"
    | "contact_phone"
    | "website"
  >
>;

export const useUpdateLabel = ({ successMessage = "Settings saved" }: { successMessage?: string } = {}) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, ...updates }: UpdateLabelVariables) => labelsApi.updateLabel(id, updates),
    onSuccess: (updatedLabel) => {
      useOrganizationStore.setState((state) => ({
        currentLabel: state.currentLabel
          ? { ...state.currentLabel, ...updatedLabel }
          : state.currentLabel,
      }));
      queryClient.invalidateQueries({ queryKey: ["label"] });
      toast.success(successMessage);
    },
    onError: () => {
      toast.error("Failed to save settings");
    },
  });
};
